/**
 * @flow
 * @relayHash 30da3609a9b893e32b67dc8ff1311975
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type Icons_getPhotoLibrary$ref = any;
export type IconsRefetchQueryVariables = {|
  page?: ?number,
  rec_per_page?: ?number,
  name?: ?string,
  file_type?: ?string,
  type?: ?string,
|};
export type IconsRefetchQueryResponse = {|
  +$fragmentRefs: Icons_getPhotoLibrary$ref
|};
export type IconsRefetchQuery = {|
  variables: IconsRefetchQueryVariables,
  response: IconsRefetchQueryResponse,
|};
*/


/*
query IconsRefetchQuery(
  $page: Int
  $rec_per_page: Int
  $name: String
  $file_type: String
  $type: String
) {
  ...Icons_getPhotoLibrary_O7n4X
}

fragment Icons_getPhotoLibrary_O7n4X on Query {
  getPhotoLibrary(page: $page, rec_per_page: $rec_per_page, name: $name, file_type: $file_type, type: $type) {
    _id
    name
    image
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "page",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "rec_per_page",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "name",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "file_type",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "type",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "file_type",
    "variableName": "file_type"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "rec_per_page",
    "variableName": "rec_per_page"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "IconsRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "Icons_getPhotoLibrary",
        "args": (v1/*: any*/)
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "IconsRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "getPhotoLibrary",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "photoLibraryType",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "_id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "image",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "IconsRefetchQuery",
    "id": null,
    "text": "query IconsRefetchQuery(\n  $page: Int\n  $rec_per_page: Int\n  $name: String\n  $file_type: String\n  $type: String\n) {\n  ...Icons_getPhotoLibrary_O7n4X\n}\n\nfragment Icons_getPhotoLibrary_O7n4X on Query {\n  getPhotoLibrary(page: $page, rec_per_page: $rec_per_page, name: $name, file_type: $file_type, type: $type) {\n    _id\n    name\n    image\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1ea577b11ac3fdbc7e9d2be215fc1f3d';
module.exports = node;
